import { QuestionMarkCircledIcon } from '@radix-ui/react-icons'
import * as Tooltip from '@radix-ui/react-tooltip'
import React from 'react'

const QuestionMarkTooltip = ({ children }: { children: React.ReactNode }) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }} className='inline-flex items-center justify-center rounded-full bg-white outline-none focus:shadow-[0_0_0_2px] focus:shadow-black'
          >
            <QuestionMarkCircledIcon />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            style={{ zIndex: '100' }}
            className='bg-white rounded-md data-[state=instant-open]:data-[side=top]:animate-slideDownAndFade data-[state=instant-open]:data-[side=right]:animate-slideLeftAndFade data-[state=instant-open]:data-[side=left]:animate-slideRightAndFade data-[state=instant-open]:data-[side=bottom]:animate-slideUpAndFade select-none text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]'
            sideOffset={5}
          >
            {children}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  )
}

export default QuestionMarkTooltip
